<section class="sh-dialog__content">
    <p>
        <sh-html-parser [message]="'classifications.zone-classifications-dialog.message' | translate"></sh-html-parser>
    </p>

    <sh-form-multi-select
        [id]="'zone-select'"
        [label]="'zone.form.zone' | translate"
        [placeholderMsg]="'zone.form.select-zone' | translate"
        [control]="zoneControl"
        [options]="zoneFormSelectOptions$ | async"
        [searchPlaceholderMsg]="'zone.form.search-zone' | translate"
        [noResultsFoundMsg]="'ui.no-results-rights' | translate"
        [listCappedMsg]="'ui.capped-results' | translate"
        [search]="true"
        [sortAlphabetically]="true"
        [limitHeightToViewport]="true"
        [inOverflownContainer]="true"
    >
    </sh-form-multi-select>

    <sh-form-multi-select
        [id]="'classification-select'"
        [label]="'classifications.form.classification' | translate"
        [placeholderMsg]="'classifications.form.select-classification' | translate"
        [control]="classificationControl"
        [options]="classificationFormSelectOptions$ | async"
        [searchPlaceholderMsg]="'classifications.form.search-classification' | translate"
        [noResultsFoundMsg]="'ui.no-results-rights' | translate"
        [listCappedMsg]="'ui.capped-results' | translate"
        [search]="true"
        [sortAlphabetically]="true"
        [limitHeightToViewport]="true"
        [inOverflownContainer]="true"
        (searchTerm)="onClassificationSearchTermChanged($event)"
    >
    </sh-form-multi-select>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="button" class="sh-button sh-action-group__item" (click)="submit()" [disabled]="!selectZoneClassificationFormGroup.valid">
            {{ config.data.yes }}
        </button>
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{ config.data.no }}</button>
    </div>
    <div class="sh-action-group -sh-align-end"></div>
</footer>
